/* KajuReise core - reward progress (5 free stones), sessionStorage persistence,
   toast feedback. Sections report completion via KajuReise.complete(key).

   Stone mapping (5 total):
     tut-gelb   - Station 1, Bogen aus 3 Gelben geschafft
     tut-orange - Station 1, Gelb durch 2 Orange ersetzt
     tut-gruen  - Station 1, Orange durch 2 Gruen ersetzt
     karten     - Station 2, Bauideen durchgesehen
     werkstatt  - Station 4, eigener Stein gegossen                             */
(function () {
  'use strict';

  var KEY = 'kaju-reise2';
  var STONES = [
    { id: 'tut-gelb', color: '#f1c953', label: 'Gelber Bogenstein' },
    { id: 'tut-orange', color: '#f39200', label: 'Oranger Bogenstein' },
    { id: 'tut-gruen', color: '#6cac53', label: 'Grüner Bogenstein' },
    { id: 'karten', color: '#0096ae', label: 'Entdecker-Stein' },
    { id: 'werkstatt', color: '#a93015', label: 'Werkstatt-Stein' }
  ];

  var state = load();
  var barEl = null, toastTimer = null;

  function load() {
    try {
      var raw = sessionStorage.getItem(KEY);
      var s = raw ? JSON.parse(raw) : {};
      if (!s.earned) s.earned = {};
      if (!s.sections) s.sections = {};
      return s;
    } catch (e) { return { earned: {}, sections: {} }; }
  }
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }

  function renderBar() {
    if (!barEl) return;
    barEl.innerHTML = '';
    for (var i = 0; i < STONES.length; i++) {
      var s = STONES[i];
      var el = document.createElement('span');
      el.className = 'reisebar__stone' + (state.earned[s.id] ? ' is-earned' : '');
      if (state.earned[s.id]) el.style.background = s.color;
      el.title = s.label;
      barEl.appendChild(el);
    }
  }

  function toast(msg) {
    var el = document.getElementById('tut-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  function renderFinaleSet() {
    var el = document.getElementById('finale-set');
    if (!el) return;
    el.innerHTML = '';
    for (var i = 0; i < STONES.length; i++) {
      var s = STONES[i];
      var d = document.createElement('span');
      d.className = 'finale__stone' + (state.earned[s.id] ? ' is-earned' : '');
      if (state.earned[s.id]) d.style.background = s.color;
      el.appendChild(d);
    }
  }

  var API = {
    // a section earned one of the 5 free stones
    earn: function (id, msg) {
      if (state.earned[id]) return;
      state.earned[id] = true;
      save();
      renderBar();
      renderFinaleSet();
      if (msg) toast(msg);
    },
    earned: function (id) { return !!state.earned[id]; },
    // free-form per-section progress (e.g. tutorial stage index) for resume
    getSection: function (key) { return state.sections[key]; },
    setSection: function (key, val) { state.sections[key] = val; save(); },
    toast: toast
  };
  window.KajuReise = API;

  function init() {
    barEl = document.getElementById('reise-stones');
    renderBar();
    renderFinaleSet();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
